function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    return function (state, action) {
        if (state === void 0) { state = {}; }
        var stateChanged = false;
        var nextState = {};
        for (var _i = 0, reducerKeys_1 = reducerKeys; _i < reducerKeys_1.length; _i++) {
            var key = reducerKeys_1[_i];
            var previousStateForKey = state[key];
            var nextStateForKey = reducers[key](previousStateForKey, action);
            nextState[key] = nextStateForKey;
            stateChanged = (stateChanged
                || (nextStateForKey !== previousStateForKey));
        }
        return (stateChanged ? nextState : state);
    };
}
export { combineReducers as default, };
//# sourceMappingURL=combineReducers.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/small-redux/es5-esm/combineReducers.js
// module id = null
// module chunks = 